/**
 * Плашка состояния подписки.
 *
 * Цвет дублируется словом, а не заменяет его: состояние должно читаться
 * и без различения оттенков.
 */
import { type Tone, toneColor } from '@/entities/subscription/state';

import styles from './Status.module.css';

export function Status({ tone, children, onHero = false }: {
  tone: Tone;
  children: string;
  onHero?: boolean;
}) {
  const className = `${styles.pill} ${onHero ? styles.onHero : styles[tone]}`;
  return (
    <span className={className} style={onHero ? { '--tone': toneColor(tone) } as never : undefined}>
      <span className={styles.dot} />
      {children}
    </span>
  );
}
